import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext);

const applyTheme = (s) => {
  if (!s) return;
  const root = document.documentElement;
  root.style.setProperty("--bg-color", s.bg_color);
  root.style.setProperty("--surface-color", s.surface_color);
  root.style.setProperty("--text-primary", s.text_primary);
  root.style.setProperty("--text-secondary", s.text_secondary);
  root.style.setProperty("--accent-color", s.accent_color);
  root.style.setProperty("--border-color", s.border_color);
  root.style.setProperty("--btn-radius", s.button_radius);
  root.style.setProperty("--font-heading", `'${s.font_heading}', sans-serif`);
  root.style.setProperty("--font-body", `'${s.font_body}', sans-serif`);
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      applyTheme(data);
    } catch (e) {
      console.error("settings load failed", e);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const update = useCallback((data) => {
    setSettings(data);
    applyTheme(data);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload: load, update }}>
      {children}
    </SettingsContext.Provider>
  );
};
